// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditionPattern_wrapper__G6_RS"};